export default (record) =>
  JSON.stringify(record).replace(
    /[` ~!@#$%^&*()_|+\-=?;:,\\.'"<>\{\}\[\]\\\/]/gi,
    '',
  );
